<div class="w-full max-w-full">
  <div class="flex items-center justify-between p-4">
    <div class="text-lg font-bold">
      {{ 'Observations' | transloco }} - {{ data.status | transloco }}
    </div>
    <button mat-icon-button (click)="dialogRef.close()" aria-label="Close">
      <mat-icon svgIcon="heroicons_outline:x"></mat-icon>
    </button>
  </div>

  <ngx-loading [show]="isLoading"></ngx-loading>

  <div class="px-4 pb-4" *ngIf="!isLoading">
    <div class="max-h-[60vh] overflow-auto border rounded">
      <table mat-table [dataSource]="observations" class="w-full">
        <!-- ID -->
        <ng-container matColumnDef="id">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-white text-xs uppercase tracking-wide w-28"
          >
            {{ 'ID' | transloco }}
          </th>
          <td mat-cell *matCellDef="let row" class="text-sm font-mono w-28">
            {{ row.unique_id || row.id }}
          </td>
        </ng-container>

        <!-- Record No. -->
        <ng-container matColumnDef="record_no">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-white text-xs uppercase tracking-wide w-32"
          >
            {{ 'record_no' | transloco }}
          </th>
          <td mat-cell *matCellDef="let row" class="text-sm font-mono w-32">
            {{ row.unifier_observation_id ? (row.unifier_observation_id | uppercase) : '-' }}
          </td>
        </ng-container>

        <!-- Sequence No. -->
        <ng-container matColumnDef="sequence_no">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-white text-xs uppercase tracking-wide w-32"
          >
            {{ 'sequence_no' | transloco }}
          </th>
          <td mat-cell *matCellDef="let row" class="text-sm font-mono w-32">
            {{ row.unifier_sequence_number ? (row.unifier_sequence_number | uppercase) : '-' }}
          </td>
        </ng-container>

        <!-- Rev# / Total Record Rev# (dynamic based on observation types) -->
        <ng-container matColumnDef="rev_no">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-white text-xs uppercase tracking-wide w-24"
          >
            {{ getRevColumnLabel() | transloco }}
          </th>
          <td mat-cell *matCellDef="let row" class="text-sm font-mono w-24">
            {{
              row.unifier_total_record_revisions !== null &&
              row.unifier_total_record_revisions !== undefined
                ? toInteger(row.unifier_total_record_revisions)
                : '-'
            }}
          </td>
        </ng-container>

        <!-- Title (clamped) -->
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef class="text-white text-xs uppercase tracking-wide">
            {{ 'Title' | transloco }}
          </th>
          <td mat-cell *matCellDef="let row" class="text-sm">
            <div class="truncate max-w-[36ch]" [matTooltip]="plain(row.title)">
              {{ plain(row.title) }}
            </div>
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-white text-xs uppercase tracking-wide w-32"
          >
            {{ 'Status' | transloco }}
          </th>
          <td mat-cell *matCellDef="let row" class="text-sm w-32">
            <span
              class="px-2 py-0.5 rounded-full text-xs flex items-center gap-2"
              [ngStyle]="{
                'background-color': statusBg(row.status),
                color: statusColor(row.status)
              }"
            >
              <span
                class="w-3 h-3 rounded-full"
                [ngStyle]="{ 'background-color': statusColor(row.status) }"
              ></span>
              {{ row.status | transloco }}
            </span>
          </td>
        </ng-container>

        <!-- Assignees -->
        <ng-container matColumnDef="assignee">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-white text-xs uppercase tracking-wide w-64"
          >
            {{ 'Assignees' | transloco }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="text-sm w-64"
            [matTooltip]="getAssigneeTooltip(row)"
            [matTooltipDisabled]="getAssignees(row).length <= 3"
          >
            <div *ngIf="getAssignees(row).length === 0" class="px-4">-</div>
            <div *ngIf="getAssignees(row).length > 0" class="grid grid-cols-2 gap-1.5 py-1">
              <mat-chip
                *ngFor="let assignee of getAssignees(row)"
                class="!text-xs !min-h-[24px] !h-6 !px-2 !rounded-full !bg-accent-100 !text-accent-700"
              >
                <span class="truncate max-w-[16ch]" [matTooltip]="assignee">{{ assignee }}</span>
              </mat-chip>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-accent-600"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="openDetails(row)"
          class="cursor-pointer hover:bg-accent-900"
        ></tr>
      </table>
    </div>

    <div
      class="flex mt-3"
      [ngClass]="{
        'justify-end': ('lang' | transloco) !== 'ar',
        'justify-start': ('lang' | transloco) === 'ar'
      }"
    >
      <mat-paginator
        [length]="meta?.total_items || observations.length"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[20, 40, 60]"
        showFirstLastButtons
        (page)="onMatPage($event)"
      ></mat-paginator>
    </div>
  </div>
</div>
